import React from "react";
import { Link } from "react-router-dom";

import bg1 from '../../assets/images/bg/bg-hosting.png'

import Navbar from "../../components/navbar";
import HelpCenter from "../../components/helpCenter";
import GetInTuch from "../../components/getInTuch";
import Footer from "../../components/footer";
import ScrollTop from "../../components/scrollTop";

import { FiArrowDown, FiArrowRight, FiX, FiCheck } from '../../assets/icons/icons'
import { domainPlan, hostingFeature } from "../../data/data";

export default function IndexHosting(){
    return(
        <>
        <Navbar navLight={true}/>

        <section className="bg-half-260 d-table w-100 bg-primary" style={{backgroundImage:`url(${bg1})`, backgroundPosition:'center'}}>
            <div className="container">
                <div className="row mt-5 justify-content-center">
                    <div className="col-12">
                        <div className="heading-title text-center">
                            <h6 className="text-white-50">Easy installation and affordable price</h6>
                            <h2 className="heading text-white title-dark mb-3">Powerful web hosting service</h2>
                            <p className="para-desc mx-auto text-white-50">Explore and learn more about everything from machine learning and global payments to  scaling your team.</p>
                            <div className="mt-4">
                                <h5 className="text-light title-dark">Start from <span className="text-warning">$3.99/month</span></h5>
                            </div>
                            <div className="mt-4">
                                <Link to="#" className="btn btn-icon btn-pills btn-lg btn-light"><FiArrowDown className="icons"/></Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section className="section">
            <div className="container">
                <div className="row justify-content-center align-items-center">
                    {hostingFeature.map((item,index) =>{
                        let Icon = item.icon
                        return(
                                <div className="col-lg-3 col-md-4 col-12 mt-4 pt-2" key={index}>
                                    <div className="card features feature-primary bg-light rounded-md p-4 border-0">
                                        <div className="icon text-center rounded-md">
                                            <h3 className="mb-0"><Icon/></h3>
                                        </div>
                                        <div className="card-body p-0 mt-3">
                                            <h5>{item.title}</h5>
                                            <p className="para text-muted mb-0">{item.desc}</p>
                                        </div>
                                    </div>
                                </div>
                        )
                    })}
                    <div className="col-lg-3 col-md-4 col-12 mt-4 pt-2">
                        <div className="text-center">
                            <Link to="#" className="btn btn-primary">See More <FiArrowRight className="fea icon-sm"/></Link>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section className="section bg-primary">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-12">
                        <div className="section-title text-center mb-4 pb-2">
                            <h4 className="title text-white title-dark mb-3">Find a personal or professional domain</h4>
                            <p className="text-white-50 para-desc mx-auto mb-0">Create, collaborate, and turn your ideas into incredible products with the definitive platform for digital design.</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section className="section">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-lg-10 mt-4 pt-2">
                        <div className="card features-absolute shadow border-0 rounded overflow-hidden">
                            <div className="p-4 bg-white">
                                <div className="input-group">
                                    <input name="name" id="name" type="text" className="form-control rounded-left" placeholder="Your domain name :"/>
                                    <div className="input-group-append" id="button-addon4">
                                        <select className="form-control rounded-0" id="domain_list">
                                            <option>.in</option>
                                            <option>.com</option>
                                            <option>.org</option>
                                            <option>.net</option>
                                            <option>.info</option>
                                            <option>.me</option>
                                        </select>
                                    </div>
                                    <input type="submit" id="search" name="search" className="searchbtn btn btn-primary" value="Search"/>
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            {domainPlan.map((item, index) =>{
                                return(
                                    <div className="col-lg-2 col-md-4 col-6 mt-4" key={index}>
                                        <Link to="#" className="text-dark">
                                            <div className="rounded shadow bg-white p-1 text-center">
                                                <h6 className="mb-0">{item.name} <br/><span className="text-primary">{item.amount}</span>/year</h6>
                                            </div>
                                        </Link>
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                </div>
            </div>

            <div className="container mt-100 mt-60">
                <div className="row justify-content-center">
                    <div className="col-12">
                        <div className="section-title text-center mb-4 pb-2">
                            <h4 className="title mb-3">Choose the convenient pricing</h4>
                            <p className="text-muted para-desc mx-auto mb-0">Create, collaborate, and turn your ideas into incredible products with the definitive platform for digital design.</p>
                        </div>
                    </div>
                </div>

                <div className="row mt-4 pt-2">
                    <div className="col-12">
                        <div className="table-responsive bg-white shadow rounded">
                            <table className="table table-center table-padding mb-0">
                                <thead>
                                    <tr>
                                        <th>&nbsp;</th>
                                        <th className="text-center p-4" style={{minWidth:'200px', maxWidth:'200px'}}>
                                            <div className="h5">Starter</div>
                                            <p className="text-muted fw-normal mt-3 mb-0">We offers a <strong>free month</strong> of service for new customers.</p>
                                            <div className="d-flex justify-content-center text-primary mt-2">
                                                <span className="h6 mb-0 mt-2">$</span>
                                                <span className="price h2 mb-0">4.99</span>
                                            </div>
                                            <p className="mb-0 text-muted fw-normal">per month</p>
                                        </th>
                                        <th className="text-center p-4" style={{minWidth:'200px', maxWidth:'200px'}}>
                                            <div className="h5">Business</div>
                                            <p className="text-muted fw-normal mt-3 mb-0">We offers a <strong>free 14 days</strong> of service for new customers.</p>
                                            <div className="d-flex justify-content-center text-primary mt-2">
                                                <span className="h6 mb-0 mt-2">$</span>
                                                <span className="price h2 mb-0">9.99</span>
                                            </div>
                                            <p className="mb-0 text-muted fw-normal">per month</p>
                                        </th>
                                        <th className="text-center p-4" style={{minWidth:'200px', maxWidth:'200px'}}>
                                            <div className="h5">Enterprise</div>
                                            <p className="text-muted fw-normal mt-3 mb-0">We offers a <strong>free 7 days</strong> of service for new customers.</p>
                                            <div className="d-flex justify-content-center text-primary mt-2">
                                                <span className="h6 mb-0 mt-2">$</span>
                                                <span className="price h2 mb-0">19.99</span>
                                            </div>
                                            <p className="mb-0 text-muted fw-normal">per month</p>
                                        </th>
                                    </tr>
                                </thead>

                                <tbody>
                                    <tr>
                                        <td className="h6">Space</td>
                                        <td className="text-center">1 GB</td>
                                        <td className="text-center">5 GB</td>
                                        <td className="text-center">20 GB</td>
                                    </tr>
                                    <tr>
                                        <td className="h6">Bandwidth</td>
                                        <td className="text-center">10 GB</td>
                                        <td className="text-center">100 GB</td>
                                        <td className="text-center">500 GB</td>
                                    </tr>
                                    <tr>
                                        <td className="h6">Email Accounts</td>
                                        <td className="text-center">100</td>
                                        <td className="text-center">1000</td>
                                        <td className="text-center">5000</td>
                                    </tr>
                                    <tr>
                                        <td className="h6">MySQL Accounts</td>
                                        <td className="text-center">100</td>
                                        <td className="text-center">1000</td>
                                        <td className="text-center">5000</td>
                                    </tr>
                                    <tr>
                                        <td className="h6">Processor</td>
                                        <td className="text-center">3Core</td>
                                        <td className="text-center">5Core</td>
                                        <td className="text-center">7Core</td>
                                    </tr>
                                    <tr>
                                        <td className="h6">CPUs</td>
                                        <td className="text-center">3.2GHz CPU</td>
                                        <td className="text-center">2x3.2GHz CPU</td>
                                        <td className="text-center">4x3.2GHz CPU</td>
                                    </tr>
                                    <tr>
                                        <td className="h6">Cpanel</td>
                                        <td className="text-center">WHM</td>
                                        <td className="text-center">WHM</td>
                                        <td className="text-center">WHM</td>
                                    </tr>
                                    <tr>
                                        <td className="h6">Support</td>
                                        <td className="text-center">Free Setup</td>
                                        <td className="text-center">24/7 Hour</td>
                                        <td className="text-center">24/7 Hour</td>
                                    </tr>
                                    <tr>
                                        <td className="h6">SSH Access</td>
                                        <td className="text-center"><FiX className="fea icon-sm text-danger"/></td>
                                        <td className="text-center"><FiX className="fea icon-sm text-danger"/></td>
                                        <td className="text-center"><FiCheck className="fea icon-sm text-success"/></td>
                                    </tr>
                                    <tr>
                                        <td className="h6">SMTP Management</td>
                                        <td className="text-center"><FiX className="fea icon-sm text-danger"/></td>
                                        <td className="text-center"><FiX className="fea icon-sm text-danger"/></td>
                                        <td className="text-center"><FiCheck className="fea icon-sm text-success"/></td>
                                    </tr>
                                    <tr>
                                        <td className="h6">FTP Access</td>
                                        <td className="text-center"><FiX className="fea icon-sm text-danger"/></td>
                                        <td className="text-center"><FiCheck className="fea icon-sm text-success"/></td>
                                        <td className="text-center"><FiCheck className="fea icon-sm text-success"/></td>
                                    </tr>
                                    <tr>
                                        <td className="h6">Google Adwords Credit</td>
                                        <td className="text-center"><FiX className="fea icon-sm text-danger"/></td>
                                        <td className="text-center"><FiCheck className="fea icon-sm text-success"/></td>
                                        <td className="text-center"><FiCheck className="fea icon-sm text-success"/></td>
                                    </tr>
                                    <tr>
                                        <td className="h6">&nbsp;</td>
                                        <td className="text-center"><Link to="#" className="btn btn-primary">Start Now</Link></td>
                                        <td className="text-center"><Link to="#" className="btn btn-primary">Buy Now</Link></td>
                                        <td className="text-center"><Link to="#" className="btn btn-primary">Buy Now</Link></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>

            <div className="container mt-100 mt-60">
                <div className="row justify-content-center">
                    <div className="col-12">
                        <div className="section-title text-center mb-4 pb-2">
                            <h4 className="title mb-4">Frequently asked questions</h4>
                            <p className="text-muted para-desc mx-auto mb-0">Create, collaborate, and turn your ideas into incredible products with the definitive platform for digital design.</p>
                        </div>
                    </div>
                </div>
                
                <HelpCenter/>

                <div className="row mt-5 pt-4 justify-content-center">
                    <GetInTuch/>
                </div>
            </div>
        </section>
        <Footer/>
        <ScrollTop/>
        </>
    )
}